import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import Nav from "./components/Nav/Nav";
import Footer from "./components/Footer/Footer";
import { useEffect, useRef } from "react";
import { toggleScrolling } from "../assets/Utils/generic";
import getLink, { LINK_TYPE } from "../config/Links";
import { ProfileRoutes } from "./pages/Profile/ProfileRoutes";
import { Retrieve } from "./components/Auth/AuthComponents";
import RequiresAuth from "./hoc/RequiresAuth";
import { useSelector } from "react-redux";
import { selectUser } from "../redux/slices/userSlice";
import { fireTagManagerEvent } from "../assets/Services/tagmanager";
import SecondaryMarket from "./pages/SecondaryMarket/SecondaryMarket";
import { useAppDispatch } from "../redux/redux";
import { setHeroVisibility } from "../redux/slices/appSlice";
import HomeRebrandingHomepage from "./pages/Directsearch/HomeRebrandingHomepage";
import { useTranslation } from "react-i18next";
import { buildLocalizedDairectUrl } from "./helpers/dairect";
import HowToResell from "./pages/HowToResell/HowToResell";

export const PROMO_AUTH_KEY =
  "vwb7n58796mm6n86b745v" + process.env.REACT_APP_FRONTEND_URI;

function scrollToTop() {
  window.scrollTo({ top: 0 });
}

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    scrollToTop();
    toggleScrolling(true);
    setTimeout(() => {
      scrollToTop();
    }, 5);
  }, [pathname]);

  return <></>;
}

function DairectRedirect({ path = "/" }: { path?: string }) {
  const { i18n } = useTranslation();

  useEffect(() => {
    window.location.replace(buildLocalizedDairectUrl(i18n.language, path));
  }, [i18n.language, path]);

  return <></>;
}

function WebRouter() {
  return (
    <>
      <Routes>
        <Route
          path="/"
          element={<HomeRebrandingHomepage />}
          key="metasearch-home-route"
        />
        <Route
          path="/secondary-market"
          element={<SecondaryMarket />}
          key="secondary-market-route"
        />
        <Route
          path="/how-to-resell"
          element={<HowToResell />}
          key="how-to-resell-route"
        />
        <Route
          path="/secondary_market"
          element={<Navigate to="/secondary-market" replace />}
          key="secondary-market-legacy-route"
        />
        <Route path="/retrieve" element={<Retrieve />} key="retrieve-route" />
        <Route
          path="/profile/*"
          element={
            <RequiresAuth>
              <ProfileRoutes />
            </RequiresAuth>
          }
          key="profile-routes"
        />
        <Route
          path="/tos"
          element={<DairectRedirect path="/tos" />}
          key="tos-route"
        />
        <Route
          path="/terms-conditions"
          element={<DairectRedirect path="/tos" />}
          key="terms-conditions-route"
        />
        <Route
          path="/privacy"
          element={<DairectRedirect path="/privacy" />}
          key="privacy-route"
        />
        <Route
          path="/cookies"
          element={<DairectRedirect path="/cookies" />}
          key="cookies-route"
        />
        <Route path="*" element={<DairectRedirect />} key="dairect-route" />
      </Routes>
    </>
  );
}

export default function Web() {
  const { pathname } = useLocation();

  const user = useSelector(selectUser);
  const dispatch = useAppDispatch();

  const isScrollHandled = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) {
        dispatch(setHeroVisibility(true));
      } else {
        dispatch(setHeroVisibility(false));
      }

      if (!isScrollHandled.current) {
        setTimerScroll();
        isScrollHandled.current = true;
      }
    };

    const setTimerScroll = () => {
      window.setTimeout(() => {
        fireTagManagerEvent("scroll_land");
      }, 5000);
    };

    window.addEventListener("scroll", handleScroll);

    if (user || localStorage.getItem(PROMO_AUTH_KEY)) return;

    // setTimeout(() => {
    //   openAuthModal(AUTH_SECTION.register_promo);

    //   localStorage.setItem(PROMO_AUTH_KEY, "true");
    // }, 60 * 1000);
  }, []);

  return (
    <>
      <div
        className={`${
          pathname.includes(getLink(LINK_TYPE.PROFILE))
            ? "white-background"
            : "black-background"
        } h100 w100`}
      >
        <Nav />
        <div
          style={{
            height: pathname.includes(getLink(LINK_TYPE.PROFILE))
              ? "calc(100dvh - 75px)"
              : "",
          }}
        >
          <WebRouter />
          <ScrollToTop />
        </div>
        <Footer />
      </div>
    </>
  );
}
